export const EDIT = 'EDIT';
export const CREATE = 'CREATE';